<i18n src="../../locales/lang.json"></i18n>

<template>
  <table style="width:100%">
    <tr>
      <td>
        <div class="row mt-1">
          <div class="col-12 col-md-6">
            <location-selector showSublocations="true" @change="onChangeLocation" loadDataOnInit="false" ref="locationselector"></location-selector>
          </div>
          <div class="col-12 col-md-6">
            <shift-select-selector loadDataOnInit="false" ref="shiftSelectorRef" @event-change-shift="onChangeShift"></shift-select-selector>
          </div>
        </div>
      </td>
    </tr>
    <tr v-show="selectedLocation == true && selectedShift == true">
      <td>
        <div class="row mt-3">
          <div class="col p-0" style="position:relative">
            <div class="" style="position:absolute;max-width:100%; overflow-x: scroll; display: block; overflow-x: scroll; margin-right: 180px;">
              <table style="border-collapse: initial;margin-bottom:5px;margin-left:-8px;margin-top:-8px;" cellspacing="8">
                <tr>
                  <td v-for="(shift, index) in data" v-bind:class="index==selectedIndex?'skin rounded dark-bg':'skin rounded dark-bg'" class="mr-2" style="min-width:250px;margin-right:5px;">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col my-1">
                          <span class="custom-table-text card-title">
                            <!--<a @click="manageShifts(shift.DayId,index)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:class="[(shift.DayId==1 && shift.LocationShifts.length > 0) || index==selectedIndex ? '' : 'collapsed']" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="margin-left:20px;color:inherit !important;">-->
                            <a @click="manageShifts(shift.DayId,index,shift.Day)" class="daylink" v-bind:href="'#accordion-child' + shift.DayId" v-bind:class="[(shift.LocationShifts.length > 0) || index==selectedIndex ? '' : 'collapsed']" v-bind:id="'accordion-control' + shift.DayId" data-toggle="collapse" aria-expanded="false" style="color:inherit !important;">
                              {{ $t(shift.Day.toLowerCase()) }}
                            </a>
                          </span>
                        </div>

                      </div>
                      <div class="row">

                        <div class="p-0" style="height: calc(-250px + 100vh); overflow-y: scroll; width: 100%;">
                          <div v-bind:id="'divdrag' +  procSch.id+'_'+procSch.Order+'_'+shift.Day+'_'+shift.DayId" v-bind:draggable="{'true':allowSort == true}" ondragstart="drag(event)" ondragend="dragend(event)" ondrop="drop(event,'locationShiftControlNew')" ondragover="allowDrop(event)" v-for="procSch in shift.Procedures" class="row skin white p-2 m-1 shadow-1 rounded">
                            <div class="col-12 p-0">
                              <div class="col-12 smaller-text" v-if="locationId == procSch.locationid" @click.self="editProcedure(procSch)">
                                {{ procSch.name }}
                                <span v-if="procSch.WeekRepeat > 0"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-rotate-cw3"></i></span>
                                <span v-if="procSch.StartDateStr !='' && procSch.EndDateStr !=''"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-calendar"></i></span>
                                <span v-if="procSch.Weekdays != null && procSch.Weekdays.indexOf(',') > -1"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-stack"></i></span>
                                <div class="dropdown" style="position: absolute; top: -5px; right: 5px; color: #aeaaaa">
                                  <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown">
                                    <i class="icon-menu" style="margin-top:-15px;margin-right:-10px;color:inherit;"></i>
                                  </a>
                                  <div class="skinnedmenu dropdown-menu dropdown-menu-right viewportfix">
                                    <a @click="removeProcdure(procSch.id,shift.DayId)" href="javascript: return false;" class="dropdown-item">{{$t('remove')}}</a>
                                    <!--<a @click="edit(procSch.id)" href="javascript: return false;" class="dropdown-item">{{$t('edit')}}</a>-->
                                  </div>
                                </div>
                              </div>
                              <div class="col-12" v-if="locationId != procSch.locationid">

                                {{procSch.locationname}} > {{ procSch.name }}
                                <span v-if="procSch.WeekRepeat > 0"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-rotate-cw3"></i></span>
                                <span v-if="procSch.StartDateStr !='' && procSch.EndDateStr !=''"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-calendar"></i></span>
                                <span v-if="procSch.Weekdays != null && procSch.Weekdays.indexOf(',') > -1"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-stack"></i></span>
                              </div>

                            </div>

                          </div>
                        </div>
                      </div>


                      <div class="row my-1 px-3">
                        <div class="col-12 px-0">
                          <!--<procedure-selector-with-add v-bind:format="true" v-bind:data="shift.DayId" ref="procedureselector" @event-add-procedure="attachProcdureShift(shift.DayId,...arguments)" @event-change-procedure="onChangeProcedure"></procedure-selector-with-add>-->
                          <procedure-or-category-selector-with-add v-bind:format="true" v-bind:data="shift.DayId" ref="procedureselector" @event-add-procedure="attachProcdureShift(shift.DayId,...arguments)" @event-change-procedure="onChangeProcedure" @event-change-category="onChangeCategory" @event-change-tag="onChangeTag" ></procedure-or-category-selector-with-add>
                        </div>
                      </div>

                    </div>





                  </td>
                </tr>
              </table>


            </div>
          </div>
        </div>
      </td>
    </tr>

  </table>

</template>

<script>
  import LocationSelector from '../location/location-selector.vue'
  import ShiftSelector from '../shift/shift-select-selector.vue'
  import ProcedureSelector from '../procedure/procedure-or-category-selector-with-add.vue'
  var selectedIndex = -1;
  export default {
    name: "location-shift-new",
    components: {
      LocationSelector,
      ShiftSelector,
      ProcedureSelector,
    },
    props: {
      selectedIndex: {
        type: Number,
        default: -1,
        
      },
    },
    data() {
      return {
        newProcedureName: '',
        siteshiftid: -1,
        locationId: -1,
        data: null,
        bgcolor: 'background-color: #F6F7F7 !important; color:black',
        activebgcolor: 'background-color: #03a9f4 !important; color:white',
        day: '',
        locationname: '',
        locShiftId: -1,
        items: [],
        procId: 0,
        tag: '',
        categoryId: 0,
        dayid: 0,
        selectedProcedureSchedule: null,
        selectedLocation: false,
        selectedShift: false
      };
    },
    methods: {
      //async loadProcedures() {
      //  try {
      //    this.items = [];
      //    this.$http.get('/api/Procedure/GetProcedures').then(async response => {

      //      this.items = response.data;

      //      if (this.items !== null && this.items.length > 0) {
      //        this.items = this.items.sort(function (a, b) {
      //          var x = a.Name.toLowerCase();
      //          var y = b.Name.toLowerCase();
      //          return x < y ? -1 : x > y ? 1 : 0;
      //        });
      //      }


      //      $("#select_procedure" + this.getId()).select2();

      //    }).then((async response => {
      //    }
      //    ));
      //  } catch (err) {

      //  }
      //},

      onOrderChange(arraydragids, arraydropids) {
        //if (!this.dataIsSortedBySelf) {
        //  return;
        //}
        var dragId = arraydragids[0];
        var dragOrder = arraydragids[1];

        var dropId = arraydropids[0];
        var dropOrder = arraydropids[1];

        //console.log("dragId=" + dragId + "dropId=" + dropId);
        if (dragId !== '' && dropId !== '' && dragId !== undefined && dropId !== undefined
          && dragId !== dropId) {

          var procedures = [];
          // checking day for drag drop elements
          if (arraydragids[3] === arraydropids[3]) {
            var item = this.data.find(n => n.DayId == arraydropids[3]);
            if (item != null) {
              procedures = item.Procedures;
            }
          }

          if (procedures !== null && procedures !== undefined && procedures.length > 0) {
            for (let i = 0; i < procedures.length; ++i) {
              if (procedures[i].id == dragId) {

                if (procedures[i].Order == dropOrder) {
                  procedures[i].Order = dropOrder + 0.1;
                } else {
                  procedures[i].Order = dropOrder;
                }
              }
            }
            procedures = procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

            for (let i = 0; i < procedures.length; ++i) {
              procedures[i].Order = i;
            }

            procedures = procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

            this.$forceUpdate();
            try {
              var url = '/api/Procedure/UpdateMultipleActivitiesOrder';
              this.$http.post(url, procedures).then(async response => {
                //this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
              });
            } catch (err) {
              alert(err);
            }
          }
          /*
          try {
            var url = '/api/Procedure/UpdateActivitiesOrderOnDrag?dragId=' + dragId
              + "&dragorder=" + dragOrder + "&dropId=" + dropId + "&droporder=" + dropOrder;
            this.$http.get(url).then(async response => {
              //this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
            });
          } catch (err) {
            alert(err);
          }
          */
        }
      },
      async removeProcdure(procId, dayid) {
        try {
          var url = '/api/Procedures/v1/RemoveProcDayShift?procSchId=' + procId + '&dayid=' + dayid;
          this.$http.get(url).then(async response => {
            this.loadLocationShiftsDay(this.locationId, this.siteshiftid, dayid);
          });
        } catch (err) {
          alert(err);
        }
      },
      async addProcedure(name, dayId) {
        var thisContext = this;
        var tmpProcedure = { name: name, istask: false };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);

        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('procedures_reload');
            thisContext.newProcedureName = '';
            thisContext.procId = response.data.Id;
            thisContext.dayid = dayId;
            thisContext.attachProcdureShift(dayId);
          });
        
      },
      async attachTagShift(dayId, name) {
        try {

          if (this.categoryId <= 0 && name != null) {
            return false;
          }
          else if (this.locationId === '' || this.locationId < 0 ||
            this.siteshiftid === '' || this.siteshiftid < 0 || this.tag === ''
             || this.dayid !== dayId)
            return false;
          var request = {
            locationId: this.locationId, day: dayId, tag: this.tag,
            shiftId: this.siteshiftid
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddTagActvities',
            request
          ).then(async response => {
            this.loadLocationShiftsDay(this.locationId, this.siteshiftid, this.dayid);
            this.tag = "";
            this.dayid = 0;
          });
        } catch (err) {
          alert(err);
        }
      },
      async attachCategoryShift(dayId, name) {
        try {

          if (this.categoryId <= 0 && name != null) {
            return false;
          }
          else if (this.locationId === '' || this.locationId < 0 ||
            this.siteshiftid === '' || this.siteshiftid < 0 || this.categoryId === ''
            || this.categoryId < 0 || this.dayid !== dayId)
            return false;

          var request = {
            locationId: this.locationId, day: dayId, categoryId: this.categoryId,
            shiftId: this.siteshiftid
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddCategoryActvities', request
          ).then(async response => {
            this.loadLocationShiftsDay(this.locationId, this.siteshiftid, this.dayid);
            this.categoryId = 0;
            this.dayid = 0;
          });
        } catch (err) {
          alert(err);
        }
      },
      async attachProcdureShift(dayId, name) {
        try {
          
          if (this.procId <= 0 && name != null) {
            //Add procedure and return the procedureId
            this.addProcedure(name, dayId);
            return false;
          }
          else if (this.locationId === '' || this.locationId < 0 ||
            this.siteshiftid === '' || this.siteshiftid < 0 || this.procId === ''
            || this.procId < 0 || this.dayid !== dayId)
            return false;
          var request = {
            locationId: this.locationId, day: dayId, procId: this.procId,
            shiftId: this.siteshiftid
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddProcActvity',
            request
          ).then(async response => {
            this.loadLocationShiftsDay(this.locationId, this.siteshiftid, this.dayid);
            this.procId = 0;
            this.dayid = 0;
          });
        } catch (err) {
          alert(err);
        }
      },
      fetchReloadData() {
        //this.loadProcedures();
        this.$refs.locationselector.fetchReloadData(this.locationId == -1 ? null : this.locationId);
        this.$refs.shiftSelectorRef.fetchReloadData();
        this.loadLocationShifts(0, 0);
      },
      onChangeProcedure(id, dayid) {
        this.procId = id;
        this.dayid = dayid;
        this.attachProcdureShift(dayid);
      },
      onChangeCategory(id, dayid) {
        this.categoryId = id;
        this.dayid = dayid;
        this.attachCategoryShift(dayid);
      },
      onChangeTag(id, dayid) {
        this.tag = id;
        this.dayid = dayid;
        this.attachTagShift(dayid);
      },
      onAddProcedure(text) {
        this.newProcedureName = text;
        //alert("add procedure:" + text);
      },
      onChangeLocation(id, text) {
        if (id == '')
          this.selectedLocation = false
        else
          this.selectedLocation = true
        this.selectedIndex = -1;
        $(".weekdaydiv").each(function () {
          $(this).removeClass('show');
        });
        if (id != '' && this.siteshiftid != '') {
          this.locationId = id;
          this.locationname = text;
          this.loadLocationShifts(this.locationId, this.siteshiftid);
        } else {
          this.locationId = -1;
        }
      },
      onChangeShift(id) {
        if (id == '')
          this.selectedShift = false;
        else 
          this.selectedShift = true;
        if (id != '' && this.locationId != '') {
          this.siteshiftid = id;
          this.loadLocationShifts(this.locationId, this.siteshiftid);
        } else {
          this.siteshiftid = -1;
        }
      },
      async loadLocationShiftsDay(locationId, siteshiftid, dayid) {
        try {
          var url = '/api/Admin/v1/Location/Shifts/Day?locationId='
            + locationId + '&shiftid=' + siteshiftid + '&dayid=' + dayid;
          this.$http.get(url).then(async response => {
            var procs = response.data;

            var item = this.data.find(n => n.DayId == dayid);
            console.log(item);
            if (item != null) {
              item.Procedures = [];
              item.Procedures = procs;
              console.log(item);
            }
            this.$forceUpdate();
          }, function (error) {
            this.data = null;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async loadLocationShifts(locationId, siteshiftid) {
        this.data = [];
        try {
          var url = `/api/Admin/v1/Location/Shifts/${locationId}/${siteshiftid}`;
          this.$http.get(url).then(async response => {
            this.data = response.data;
            this.$forceUpdate();
          }, function (error) {
            this.data = null;
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      getId() {
        return this._uid;
      },
      editProcedure(procSchedule) {
        this.selectedProcedureSchedule = procSchedule;
        this.$root.$emit("editprocedure", procSchedule.procedureId)
      },
      procedureUpdated(val) {
        var storeProcedure = this.$store.getProcedure();
        if (this.selectedProcedureSchedule != null && storeProcedure.ProcedureId == this.selectedProcedureSchedule.procedureId) {
          this.selectedProcedureSchedule.name = storeProcedure.ProcedureName
        }
        //else
        //  alert("updated another procedure");
      }
    },
    watch: {
    },
    mounted() {
      this.placeholder = this.$store.translate('select_template');
      this.$refs.locationselector.displayAddButton = false;
      this.$root.$on('procedure_editor_can_close', this.procedureUpdated);
      this.$root.$on('procedure_changed', this.procedureUpdated);
      this.$root.$on('procedure_loaded', this.procedureUpdated);
      
      //this.$root.$on('procedure_reset', this.procedureUpdated);
      
    }
  };
</script>

<style scoped>

  .card-group-control .card-title > a.collapsed::before {
    content: "\e9ca" !important;
  }

  .card-group-control .card-title > a.collapsed:before {
    content: "";
  }

  .card-group-control .card-title > a::before {
    content: "\e9c9" !important;
  }

  .daylink::before {
    left: 0px !important;
  }


  .alternating tr {
    border-top: 1px solid #ccc;
  }

    .alternating tr:first-child {
      border-top: 1px solid white;
    }

  .select_container {
    width: calc(100%)
  }

  .custom-table-text {
    font-size: 14px;
    height: 40px;
  }

  .smaller-text{
      font-size:12px;
  }

  @media screen and (max-width:768px) {
    .custom-table-text {
      font-size: 10px;
    }
  }

  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/location-shift-new.vue